import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class SpecialProgrammesCountryRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 2 &&
			indexableFilters.some((_) => _.type === ParameterType.SPECIAL_PROGRAMMES) &&
			indexableFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.SPECIAL_PROGRAMMES_COUNTRY_ROUTE,
			params: {
				special_programmes: this.extractPath(filters.find((_) => _.type === ParameterType.SPECIAL_PROGRAMMES)),
				country: this.extractPath(filters.find((_) => _.type === ParameterType.COUNTRY)),
			},
		};
	}
}